export default "__VITE_ASSET__DooF0rnQ__"